/**
 * Animation duration for WebSocket button dismiss animation (in milliseconds).
 * This should match the CSS animation duration in WsButton.scss.
 */
export const WS_BUTTON_DISMISS_ANIMATION_DURATION = 300;
